import * as React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from '@mui/material/IconButton';
import Bs4GenericField from './Bs4GenericField';
import Bs4MainDispatch from '../../Bs4MainDispatch';
import { IMaskInput } from 'react-imask';

import Typography from '@mui/material/Typography';

export default class Bs4Text extends Bs4GenericField {

  setValueBs4(value) {
    this.setValue(value || '');
  }

  reloadGridCriteriaTimeoutID = null;
  reloadGridCriteriaLastValue = null;

  ViewSummaryDetails = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');

    const handleChange = (e) => {      
      this.setValue(e.target.value);
      try {
        if (this.getValue().length < 3 && !(!this.getValue() && this.reloadGridCriteriaLastValue)) return;
        clearTimeout(this.reloadGridCriteriaTimeoutID);
        this.reloadGridCriteriaLastValue = this.getValue();
        this.reloadGridCriteriaTimeoutID = setTimeout(() => {
          this.reloadGridCriteria();
        }, 500);
      } catch (error) {}
    }

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || '');
      })    
    }, []);              

    const TextMaskCustom = React.useMemo(() => {
      const TextMaskCustom = React.forwardRef((props, ref) => {
        const { onChange, ...other } = props;
        return (
          <IMaskInput
            {...other}
            mask={formField.props.field.field_text_mask}
            definitions={{'#': /[1-9]/,}}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
          />
        );
      });
      // TextMaskCustom.propTypes = {
      //   name: PropTypes.string.isRequired,
      //   onChange: PropTypes.func.isRequired,
      // };
      return TextMaskCustom;
    }, [formField.props.field.field_text_mask])

    if (this.readOnly) return <Typography>{value}</Typography>
    
    else return (      
      <TextField 
        value={value} 
        onChange={handleChange} 
        autoComplete='off'
        slotProps={{          
          input: {
            inputComponent: formField.props.field.field_text_mask ? TextMaskCustom : null,
          },
        }}
      />
    );
  }
    
  ViewComponentField = (props) => {    
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);
    this.refFocus = React.useRef();
    
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || '');
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);

    const handleChange = (e) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      // const v0 = encodeURI(e.target.value);
      // const v1 = decodeURI(v0);
      // console.log('...TEXT...', e.target.value, v0, v1);
      this.setValue(e.target.value);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    }  

    const handleClickAdornmentPadr_url = (e) => {
      const url = formField.props.field.padr_url;
      const appleBs4 = Bs4MainDispatch.getAppleBs4();
      if (appleBs4) window.open(url, '_self');
      else window.open(url, '_blank'); 
    }

    const adornmentPadr_url = React.useMemo(() => {
      return formField.props.field.padr_url ? (
        <InputAdornment position="start">
          <IconButton onClick={handleClickAdornmentPadr_url}>
            <i className="fa-thin fa-globe-pointer"/>
          </IconButton>
        </InputAdornment>
      ) : null;
    }, [formField.props.field.padr_url]);

    const TextMaskCustom = React.useMemo(() => {
      const TextMaskCustom = React.forwardRef((props, ref) => {
        const { onChange, ...other } = props;
        return (
          <IMaskInput
            {...other}
            mask={formField.props.field.field_text_mask}
            definitions={{'#': /[0-9]/,}}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
          />
        );
      });
      // TextMaskCustom.propTypes = {
      //   name: PropTypes.string.isRequired,
      //   onChange: PropTypes.func.isRequired,
      // };
      return TextMaskCustom;
    }, [formField.props.field.field_text_mask])

    return (
      <TextField
        id={formField.props.inputId} 
        name={formField.props.inputId}
        inputRef={formField.refFocus}
        fullWidth={props.fullWidth}
        label={<formField.Bs4Label/>}
        slotProps={{
          inputLabel: formField.props.field.hideLabel ? {sx:{display:'none'}} : null,
          htmlInput: {readOnly: formField.readOnly},
          input: {
            disableUnderline: formField.readOnly,
            startAdornment: adornmentPadr_url,
            inputComponent: formField.props.field.field_text_mask ? TextMaskCustom : null,
          },
        }}
        value={value}
        onChange={handleChange}
        error={error.error}
        helperText={error.helperText}
        autoComplete='off'              
      />
    );
  }
}